export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: React.ReactNode }) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4 pb-2 pt-7 sm:pt-9">
      <div>
        {eyebrow ? <div className="mb-2 text-[11px] font-medium uppercase tracking-[0.16em] text-ink-faint">{eyebrow}</div> : null}
        <h1 className="text-2xl font-semibold tracking-[-0.035em] text-ink">{title}</h1>
        {description ? <p className="mt-1 text-sm text-ink-muted">{description}</p> : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </header>
  )
}
